export { default as WorkHours } from './WorkHours';
